import { styled } from 'styled-components'
import BasicButton from '@web-ui-kit/basic-button'
import SPACES from '@web-ui-kit/spaces'
import { DEVICE_SIZE } from 'utils/constants'

export const Container = styled.div`
  margin: 0 auto;
  max-width: 70.5rem;
  padding-top: ${SPACES['5XL']};
  text-align: center;

  @media (width < ${DEVICE_SIZE.TABLET}) {
    padding: ${SPACES['5XL']} ${SPACES['S']} 0;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACES.L};
  margin: ${SPACES['4XL']} auto;
  max-width: 29rem;
  text-align: left;
  width: 100%;
`

export const TooltipText = styled.div`
  max-width: 14.75rem;
  padding: ${SPACES.XS};
`

export const SubmitButton = styled(BasicButton)`
  min-width: 100%;
`

export const CancelButton = styled(BasicButton)`
  margin: 0 auto;
  max-width: 11.5rem;
`
